// Keyfile runtime storage. The ML-DSA-65 keyfile (with secret_key_hex) is kept
// in sessionStorage so it survives page reloads within the same tab/session and
// is automatically cleared when the browser tab is closed. No passphrase prompt:
// account security is enforced server-side by the login second factor (PIN/2FA).
import { lockEnabled, bindVault, stashKeyfile } from "@/lib/weblock";

const RT_KEY = "lattice_keyfile_rt";
const LEGACY_KEY = "lattice_keyfile";
const LEGACY_VAULT = "lattice_keyfile_vault";

let _runtime = null;

// AUDIT v3.1.0: con il doppio PIN attivo la chiave privata NON resta in chiaro da nessuna
// parte. Vive in RAM mentre l'app è aperta e, per sopravvivere al blocco, solo dentro la
// cassetta cifrata con il PIN reale (`lib/weblock.js`). Sotto il PIN di copertura non c'è
// nulla da leggere: né dalla console, né ricaricando la pagina.
export const setRuntimeKeyfile = (kf) => {
  _runtime = kf || null;
  if (lockEnabled()) {
    try { sessionStorage.removeItem(RT_KEY); } catch { /* ignore */ }
    if (kf) stashKeyfile(kf);
    return;
  }
  try {
    if (kf) sessionStorage.setItem(RT_KEY, JSON.stringify(kf));
    else sessionStorage.removeItem(RT_KEY);
  } catch { /* sessionStorage unavailable */ }
};

export const getRuntimeKeyfile = () => {
  if (_runtime) return _runtime;
  if (lockEnabled()) return null; // la copia cifrata la riapre soltanto il PIN reale
  try {
    const raw = sessionStorage.getItem(RT_KEY);
    if (raw) { _runtime = JSON.parse(raw); return _runtime; }
  } catch { /* ignore */ }
  return null;
};

export const clearRuntimeKeyfile = () => {
  _runtime = null;
  try { sessionStorage.removeItem(RT_KEY); } catch { /* ignore */ }
};

// Replace the runtime keyfile (e.g. after key rotation) — persists for the session.
export const updateRuntimeKeyfile = (kf) => { if (kf) setRuntimeKeyfile(kf); };

// Richiede lo sblocco quando l'utente è autenticato ma il file chiave non è
// presente in questa scheda/sessione (es. nuova tab: la chiave è per-tab).
export const needsUnlock = () => getRuntimeKeyfile() === null;
export const hasVault = () => false;

export const clearVault = () => {
  clearRuntimeKeyfile();
  try {
    localStorage.removeItem(LEGACY_KEY);
    localStorage.removeItem(LEGACY_VAULT);
  } catch { /* ignore */ }
};

// Il lucchetto ha bisogno di leggere/scrivere/azzerare il file chiave, ma non deve
// importare questo modulo (import circolare): è questo modulo a presentarsi.
bindVault({ get: getRuntimeKeyfile, set: setRuntimeKeyfile, wipe: clearRuntimeKeyfile });
